import React, { useContext } from 'react';
import './Footer.css';
import { ThemeContext } from './ThemeContext';

const Footer = () => {
  const { isDarkMode } = useContext(ThemeContext);

  const linkedinIcon = isDarkMode ? './icons/linkedin-neon.svg' : './icons/linkedin-light.png';
  const githubIcon = isDarkMode ? './icons/github2.svg' : './icons/github.svg';

  // Set individual sizes for each logo based on the theme
  const linkedinSize = isDarkMode ? '60px' : '80px';
  const githubSize = isDarkMode ? '70px' : '57px';

  return (
    <footer className="footer">
      <p className="footer-text">Copyright © 2025. Pranit Singh Gandhi</p>
      <a href="https://www.linkedin.com/in/pranit-gandhi" target="_blank" rel="noopener noreferrer">
        <img
          src={linkedinIcon}
          alt="LinkedIn"
          className="footer-icon linkedin-logo"
          style={{ width: linkedinSize, height: linkedinSize }}
        />
      </a>
      <a href="https://github.com/pranit-gandhi" target="_blank" rel="noopener noreferrer">
        <img
          src={githubIcon}
          alt="GitHub"
          className="footer-icon"
          style={{ width: githubSize, height: githubSize }}
        />
      </a>
    </footer>
  );
};

export default Footer;
